import {
    LIST_FTL_COSTS, LIST_SHIPPING_COSTS,
    STORE_FTL_COSTS, STORE_SHIPPING_COSTS,
} from '../../constants/ftlCosts';

export const listFTLCosts = () => ({
    type: LIST_FTL_COSTS
})

export const storeFTLCosts = (ftlCosts) => ({
    type: STORE_FTL_COSTS,
    ftlCosts
})


export const listShippingCosts = () => ({
    type: LIST_SHIPPING_COSTS,
})

export const storeShippingCosts = (shippingCosts) => ({
    type: STORE_SHIPPING_COSTS,
    shippingCosts
})